module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/biolerplate-295.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/install/biolerplate.md
// module id = 760
// module chunks = 464